


const getCurrentTime = () => {
    const options = { hour: 'numeric', minute: 'numeric', second: 'numeric' };
    const trLocale = 'tr-TR';
    
    const now = new Date();
    const formattedTime = now.toLocaleTimeString(trLocale, options);
  
    return formattedTime;

}

export default getCurrentTime